import * as React from 'react';
import { useStore } from './store';

const ConfirmItem = React.lazy(() => import('./ConfirmItem'));

const GlobalConfirm = () => {
  const { confirms } = useStore();

  if (confirms.length <= 0) {
    return null;
  }
  return (
    <>
      <React.Suspense fallback={null}>
        {confirms.map((confirm) => {
          return <ConfirmItem key={confirm.id} {...confirm} />;
        })}
      </React.Suspense>
    </>
  );
};

export default GlobalConfirm;
